import {
    PRECIO_JUSTO_GET_CSV_MARKET_PRICES_BEGIN,
    PRECIO_JUSTO_GET_CSV_MARKET_PRICES_SUCCESS,
    PRECIO_JUSTO_GET_CSV_MARKET_PRICES_FAILURE,
    PRECIO_JUSTO_CLEAN_GET_CSV_MARKET_PRICES_FAILURE
  } from '../../precio-justo/redux/constants';

import { BFFAgent } from 'BFFAgent';
  
  export function getCSVMarketPrices() {
    return async dispatch =>{
        dispatch({
            type:PRECIO_JUSTO_GET_CSV_MARKET_PRICES_BEGIN,
        })
            const res = await BFFAgent.FairPrice.getCSVMarketPrices()
            if (res)
              dispatch({
                  type:PRECIO_JUSTO_GET_CSV_MARKET_PRICES_SUCCESS
              })
            else
              dispatch({
                  type:PRECIO_JUSTO_GET_CSV_MARKET_PRICES_FAILURE,
              })
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PRECIO_JUSTO_GET_CSV_MARKET_PRICES_BEGIN:
        return {
          ...state,
          loadingCSVMarketPrices:true,
          errorCSVMarketPrices:false
        };
      case PRECIO_JUSTO_GET_CSV_MARKET_PRICES_SUCCESS:
        return{
            ...state,
            loadingCSVMarketPrices:false
        }
      case PRECIO_JUSTO_GET_CSV_MARKET_PRICES_FAILURE:
        return{
            ...state,
            loadingCSVMarketPrices:false,
            errorCSVMarketPrices:true
        }
      case PRECIO_JUSTO_CLEAN_GET_CSV_MARKET_PRICES_FAILURE:
      return{
          ...state,
          errorCSVMarketPrices:false,
          loadingCSVMarketPrices:false
        }
  
      default:
        return state;
    }
  }
  